import * as configs from '../survey/configs';

type StepConfig = { name: string; [key: string]: unknown };
type ConfigsMap = Record<string, StepConfig[]>;

export default function useResolvedConfig(config: string | null): StepConfig[] {
  const map = configs as unknown as ConfigsMap;

  if (config === 'customV2') {
    return map.customV18;
  }
  return config && config in configs ? map[config] : map.customV18;
}
